import { RouteHandler } from 'wee-routes';
import $screen from 'wee-screen';
import Vue from 'vue';
import mobileSearchOptions from './mobile/index.vue';
import desktopSearchOptions from './desktop/index.vue';

export const MobileSearch = Vue.extend(mobileSearchOptions);
export const DesktopSearch = Vue.extend(desktopSearchOptions);

let mobileSearch;
let desktopSearch;

export default new RouteHandler({
    init() {
        $screen.map([
            {
                max: 3,
                once: true,
                callback() {
                    mobileSearch = new MobileSearch().$mount('.js-search-mobile');

                    if (desktopSearch && desktopSearch.close) {
                        desktopSearch.close();
                    }
                },
            },
            {
                min: 4,
                once: true,
                callback() {
                    desktopSearch = new DesktopSearch().$mount('.js-search-desktop');

                    if (mobileSearch && mobileSearch.close) {
                        mobileSearch.close();
                    }
                },
            },
        ]);
    },
});
